module.exports = __webpack_public_path__ + "img/sv20.060d757d.svg";